import { QuoteResponse } from '../../models/quote/quote-response';
import { mockCheckoutOffers } from '../checkout/checkout-offers.mock';

export const mockQuoteResponse: QuoteResponse = {
  status: 200,
  interactionId: 'abc123',
  personId: 'person456',
  items: [
    {
      id: 'item1',
      operationalStatusAtPos: 'ACTIVE',
    },
    {
      id: 'item2',
      operationalStatusAtPos: 'INACTIVE',
    },
  ],
  offer: mockCheckoutOffers[0],
};
